import {
  PermissionKeys,
  PermissionTypes,
} from 'src/@smartmanufacturing/common/enum';
import { Permission } from './permission';

export class ApplicationPermission {
  // departments defined permissions
  public static DEPARTMENTS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Departments,
    PermissionType: PermissionTypes.IsRead,
  };
  public static DEPARTMENTS_CREATE: Permission = {
    PermissionKey: PermissionKeys.Departments,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static DEPARTMENTS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Departments,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static DEPARTMENTS_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Departments,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static DEPARTMENTS_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Departments,
    PermissionType: PermissionTypes.IsDeactivate,
  };
  public static DEPARTMENTS_DELETE: Permission = {
    PermissionKey: PermissionKeys.Departments,
    PermissionType: PermissionTypes.IsDelete,
  };

  // group defined permissions
  public static GROUP_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Groups,
    PermissionType: PermissionTypes.IsRead,
  };
  public static GROUP_CREATE: Permission = {
    PermissionKey: PermissionKeys.Groups,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static GROUP_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Groups,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static GROUP_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Groups,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static GROUP_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Groups,
    PermissionType: PermissionTypes.IsDeactivate,
  };

  // role defined permissions
  public static ROLE_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ManageRoles,
    PermissionType: PermissionTypes.IsRead,
  };
  public static ROLE_CREATE: Permission = {
    PermissionKey: PermissionKeys.ManageRoles,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static ROLE_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ManageRoles,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static ROLE_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.ManageRoles,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static ROLE_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.ManageRoles,
    PermissionType: PermissionTypes.IsDeactivate,
  };
  // user defined permissions
  public static USER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsRead,
  };
  public static USER_CREATE: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static USER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static USER_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static USER_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsDeactivate,
  };
  public static USER_APPROVE: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsApprove,
  };
  public static USER_REJECT: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsReject,
  };
  public static USER_DELETE: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsDelete,
  };

  // plant defined permissions
  public static PLANT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PLANT_CREATE: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PLANT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PLANT_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static PLANT_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsDeactivate,
  };
  // EMPLOYEE defined permissions
  public static EMPLOYEE_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Employees,
    PermissionType: PermissionTypes.IsRead,
  };
  public static EMPLOYEE_CREATE: Permission = {
    PermissionKey: PermissionKeys.Employees,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static EMPLOYEE_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Employees,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static EMPLOYEE_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Employees,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static EMPLOYEE_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Employees,
    PermissionType: PermissionTypes.IsDeactivate,
  };

  // EMPLOYEE defined permissions
  public static MULTIPLE_PLANT_REQUESTS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MultiplePlantRequests,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MULTIPLE_PLANT_REQUESTS_APPROVE: Permission = {
    PermissionKey: PermissionKeys.MultiplePlantRequests,
    PermissionType: PermissionTypes.IsApprove,
  };
  public static MULTIPLE_PLANT_REQUESTS_REJECT: Permission = {
    PermissionKey: PermissionKeys.MultiplePlantRequests,
    PermissionType: PermissionTypes.IsReject,
  };

  // ---------KPI Management Module--------
  // KPI Master
  public static KPI_MASTER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.KpiMaster,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_MASTER_CREATE: Permission = {
    PermissionKey: PermissionKeys.KpiMaster,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_MASTER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.KpiMaster,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_MASTER_DELETE: Permission = {
    PermissionKey: PermissionKeys.KpiMaster,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI Actual Entry
  public static KPI_ACTUAL_ENTRY_ACCESS: Permission = {
    PermissionKey: PermissionKeys.KPIActualEntry,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_ACTUAL_ENTRY_CREATE: Permission = {
    PermissionKey: PermissionKeys.KPIActualEntry,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_ACTUAL_ENTRY_UPDATE: Permission = {
    PermissionKey: PermissionKeys.KPIActualEntry,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_ACTUAL_ENTRY_DELETE: Permission = {
    PermissionKey: PermissionKeys.KPIActualEntry,
    PermissionType: PermissionTypes.IsDelete,
  };

  //KPI Integration
  public static KPI_INTEGRATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.KPIIntegration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_INTEGRATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.KPIIntegration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_INTEGRATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.KPIIntegration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_INTEGRATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.KPIIntegration,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI Tree
  public static KPI_TREE_ACCESS: Permission = {
    PermissionKey: PermissionKeys.KPITree,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_TREE_CREATE: Permission = {
    PermissionKey: PermissionKeys.KPITree,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_TREE_UPDATE: Permission = {
    PermissionKey: PermissionKeys.KPITree,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_TREE_DELETE: Permission = {
    PermissionKey: PermissionKeys.KPITree,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI Grid View
  public static KPI_Grid_View_ACCESS: Permission = {
    PermissionKey: PermissionKeys.KPIGridView,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_Grid_View_CREATE: Permission = {
    PermissionKey: PermissionKeys.KPIGridView,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_Grid_View_UPDATE: Permission = {
    PermissionKey: PermissionKeys.KPIGridView,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_Grid_View_DELETE: Permission = {
    PermissionKey: PermissionKeys.KPIGridView,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI Data Points
  public static KPI_DATA_POINTS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.KPIDataPoints,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_DATA_POINTS_CREATE: Permission = {
    PermissionKey: PermissionKeys.KPIDataPoints,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_DATA_POINTS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.KPIDataPoints,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_DATA_POINTS_DELETE: Permission = {
    PermissionKey: PermissionKeys.KPIDataPoints,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI Tree Version
  public static KPI_TREE_VERSION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.KPITreeVersion,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_TREE_VERSION_CREATE: Permission = {
    PermissionKey: PermissionKeys.KPITreeVersion,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_TREE_VERSION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.KPITreeVersion,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_TREE_VERSION_DELETE: Permission = {
    PermissionKey: PermissionKeys.KPITreeVersion,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI Financial Gap Analysis
  public static KPI_FINANCIAL_GAP_ANALYSIS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.KPIFinancialGapAnalysis,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_FINANCIAL_GAP_ANALYSIS_CREATE: Permission = {
    PermissionKey: PermissionKeys.KPIFinancialGapAnalysis,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_FINANCIAL_GAP_ANALYSIS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.KPIFinancialGapAnalysis,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_FINANCIAL_GAP_ANALYSIS_DELETE: Permission = {
    PermissionKey: PermissionKeys.KPIFinancialGapAnalysis,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Autonomous -> AM Master -> Defect Configuration
  public static DEFECT_MANAGEMENT_MASTER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.DefectConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static DEFECT_MANAGEMENT_MASTER_CREATE: Permission = {
    PermissionKey: PermissionKeys.DefectConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static DEFECT_MANAGEMENT_MASTER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.DefectConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static DEFECT_MANAGEMENT_MASTER_DELETE: Permission = {
    PermissionKey: PermissionKeys.DefectConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI Gap Analysis
  public static KPI_GAP_Analysis_ACCESS: Permission = {
    PermissionKey: PermissionKeys.KPIGapAnalysis,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_GAP_ANALYSIS_CREATE: Permission = {
    PermissionKey: PermissionKeys.KPIGapAnalysis,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_GAP_ANALYSIS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.KPIGapAnalysis,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_GAP_ANALYSIS_DELETE: Permission = {
    PermissionKey: PermissionKeys.KPIGapAnalysis,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI Raci Matrix Report
  public static KPI_RACI_MATRIX_REPORT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.RACIMatrix,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_RACI_MATRIX_REPORT_CREATE: Permission = {
    PermissionKey: PermissionKeys.RACIMatrix,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_RACI_MATRIX_REPORT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.RACIMatrix,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_RACI_MATRIX_REPORT_DELETE: Permission = {
    PermissionKey: PermissionKeys.RACIMatrix,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI Yearly Scoreboard Report
  public static KPI_YEARLY_SCOREBOARD_REPORT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.YearlyScorecard,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_YEARLY_SCOREBOARD_REPORT_CREATE: Permission = {
    PermissionKey: PermissionKeys.YearlyScorecard,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_YEARLY_SCOREBOARD_REPORT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.YearlyScorecard,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_YEARLY_SCOREBOARD_REPORT_DELETE: Permission = {
    PermissionKey: PermissionKeys.YearlyScorecard,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI ScoreCaard
  public static KPI_SCORECARD_ACCESS: Permission = {
    PermissionKey: PermissionKeys.KpiScoreCard,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_SCORECARD_CREATE: Permission = {
    PermissionKey: PermissionKeys.KpiScoreCard,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_SCORECARD_UPDATE: Permission = {
    PermissionKey: PermissionKeys.KpiScoreCard,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_SCORECARD_DELETE: Permission = {
    PermissionKey: PermissionKeys.KpiScoreCard,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI Target Report
  public static KPI_TARGET_REPORT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.KPITargetReport,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_TARGET_REPORT_CREATE: Permission = {
    PermissionKey: PermissionKeys.KPITargetReport,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_TARGET_REPORT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.KPITargetReport,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_TARGET_REPORT_DELETE: Permission = {
    PermissionKey: PermissionKeys.KPITargetReport,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI IPE Report
  public static KPI_IPE_REPORT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.IPE,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_IPE_REPORT_CREATE: Permission = {
    PermissionKey: PermissionKeys.IPE,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_IPE_REPORT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.IPE,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_IPE_REPORT_DELETE: Permission = {
    PermissionKey: PermissionKeys.IPE,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI IPE Summary Report
  public static KPI_IPE_SUMMARY_REPORT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.IPESummary,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_IPE_SUMMARY_REPORT_CREATE: Permission = {
    PermissionKey: PermissionKeys.IPESummary,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_IPE_SUMMARY_REPORT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.IPESummary,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_IPE_SUMMARY_REPORT_DELETE: Permission = {
    PermissionKey: PermissionKeys.IPESummary,
    PermissionType: PermissionTypes.IsDelete,
  };

  // AUDIT MANAGEMENT
  // Audit Master
  public static AM_AUDIT_MASTER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.AuditMaster,
    PermissionType: PermissionTypes.IsRead,
  };
  public static AM_AUDIT_MASTER_CREATE: Permission = {
    PermissionKey: PermissionKeys.AuditMaster,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static AM_AUDIT_MASTER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.AuditMaster,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static AM_AUDIT_MASTER_DELETE: Permission = {
    PermissionKey: PermissionKeys.AuditMaster,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Audit Master For AM Gernal Setting
  public static AUDIT_MASTER_CLI_ACCESS: Permission = {
    PermissionKey: PermissionKeys.AMGeneralSettings,
    PermissionType: PermissionTypes.IsRead,
  };
  public static AUDIT_MASTER_CLI_CREATE: Permission = {
    PermissionKey: PermissionKeys.AMGeneralSettings,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static AUDIT_MASTER_CLI_UPDATE: Permission = {
    PermissionKey: PermissionKeys.AMGeneralSettings,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static AUDIT_MASTER_CLI_DELETE: Permission = {
    PermissionKey: PermissionKeys.AMGeneralSettings,
    PermissionType: PermissionTypes.IsDelete,
  };

  //ManageChecklist
  public static AM_MANAGE_CHECKLIST_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ManageChecklist,
    PermissionType: PermissionTypes.IsRead,
  };
  public static AM_MANAGE_CHECKLIST_CREATE: Permission = {
    PermissionKey: PermissionKeys.ManageChecklist,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static AM_MANAGE_CHECKLIST_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ManageChecklist,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static AM_MANAGE_CHECKLIST_DELETE: Permission = {
    PermissionKey: PermissionKeys.ManageChecklist,
    PermissionType: PermissionTypes.IsDelete,
  };
  //Inspections
  public static AM_INSPECTIONS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Inspections,
    PermissionType: PermissionTypes.IsRead,
  };
  public static AM_INSPECTIONS_CREATE: Permission = {
    PermissionKey: PermissionKeys.Inspections,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static AM_INSPECTIONS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Inspections,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static AM_INSPECTIONS_DELETE: Permission = {
    PermissionKey: PermissionKeys.Inspections,
    PermissionType: PermissionTypes.IsDelete,
  };
  //InspectionPlan
  public static AM_INSPECTION_PLAN_ACCESS: Permission = {
    PermissionKey: PermissionKeys.InspectionPlan,
    PermissionType: PermissionTypes.IsRead,
  };
  public static AM_INSPECTION_PLAN_CREATE: Permission = {
    PermissionKey: PermissionKeys.InspectionPlan,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static AM_INSPECTION_PLAN_UPDATE: Permission = {
    PermissionKey: PermissionKeys.InspectionPlan,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static AM_INSPECTION_PLAN_DELETE: Permission = {
    PermissionKey: PermissionKeys.InspectionPlan,
    PermissionType: PermissionTypes.IsDelete,
  };
  //NCR
  public static AM_NCR_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ExecutedTaskList,
    PermissionType: PermissionTypes.IsRead,
  };
  public static AM_NCR_CREATE: Permission = {
    PermissionKey: PermissionKeys.ExecutedTaskList,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static AM_NCR_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ExecutedTaskList,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static AM_NCR_DELETE: Permission = {
    PermissionKey: PermissionKeys.ExecutedTaskList,
    PermissionType: PermissionTypes.IsDelete,
  };
  //AuditTaskDashboard
  public static AM_AUDIT_TASK_DASHBOARD_ACCESS: Permission = {
    PermissionKey: PermissionKeys.AuditTaskDashboard,
    PermissionType: PermissionTypes.IsRead,
  };
  public static AM_AUDIT_TASK_DASHBOARD_CREATE: Permission = {
    PermissionKey: PermissionKeys.AuditTaskDashboard,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static AM_AUDIT_TASK_DASHBOARD_UPDATE: Permission = {
    PermissionKey: PermissionKeys.AuditTaskDashboard,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static AM_AUDIT_TASK_DASHBOARD_DELETE: Permission = {
    PermissionKey: PermissionKeys.AuditTaskDashboard,
    PermissionType: PermissionTypes.IsDelete,
  };
  //Pest Control 
  public static DECTECTOR_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Detector,
    PermissionType: PermissionTypes.IsRead,
  };
  public static DETECTOR_CREATE: Permission = {
    PermissionKey: PermissionKeys.Detector,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static DETECTOR_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Detector,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static DETECTOR_DELETE: Permission = {
    PermissionKey: PermissionKeys.Detector,
    PermissionType: PermissionTypes.IsDelete,
  };
  //Pest Control Priority
  public static PRIORITY_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Detector,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PRIORITY_CREATE: Permission = {
    PermissionKey: PermissionKeys.Detector,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PRIORITY_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Detector,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PRIORITY_DELETE: Permission = {
    PermissionKey: PermissionKeys.Detector,
    PermissionType: PermissionTypes.IsDelete,
  };

  // ---------Analytical Tools Module--------
  //RCA & SWOT Analysis
  public static ANALYTICAL_TOOLS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.RCASWOTAnalysis,
    PermissionType: PermissionTypes.IsRead,
  }
  public static ANALYTICAL_TOOLS_CREATE: Permission = {
    PermissionKey: PermissionKeys.RCASWOTAnalysis,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static ANALYTICAL_TOOLS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.RCASWOTAnalysis,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static ANALYTICAL_TOOLS_DELETE: Permission = {
    PermissionKey: PermissionKeys.RCASWOTAnalysis,
    PermissionType: PermissionTypes.IsDelete,
  }

  public static ANALYTICAL_TOOLS_SWOT_PESTLE_ACCESS: Permission = {
    PermissionKey: PermissionKeys.SWOTPESTLEAnalysis,
    PermissionType: PermissionTypes.IsRead,
  }
  public static ANALYTICAL_TOOLS_SWOT_PESTLE_CREATE: Permission = {
    PermissionKey: PermissionKeys.SWOTPESTLEAnalysis,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static ANALYTICAL_TOOLS_SWOT_PESTLE_UPDATE: Permission = {
    PermissionKey: PermissionKeys.SWOTPESTLEAnalysis,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static ANALYTICAL_TOOLS_SWOT_PESTLE_DELETE: Permission = {
    PermissionKey: PermissionKeys.SWOTPESTLEAnalysis,
    PermissionType: PermissionTypes.IsDelete,
  }


  //--------Document Management----------//
  public static DOCUMENT_MANAGEMENT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.DocumentsManagement,
    PermissionType: PermissionTypes.IsRead,
  }
  public static DOCUMENT_MANAGEMENT_CREATE: Permission = {
    PermissionKey: PermissionKeys.DocumentsManagement,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static DOCUMENT_MANAGEMENT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.DocumentsManagement,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static DOCUMENT_MANAGEMENT_DELETE: Permission = {
    PermissionKey: PermissionKeys.DocumentsManagement,
    PermissionType: PermissionTypes.IsDelete,
  }
  public static DOCUMENT_MANAGEMENT_ISACTIVATE: Permission = {
    PermissionKey: PermissionKeys.DocumentsManagement,
    PermissionType: PermissionTypes.IsActivate,
  }
  public static DOCUMENT_MANAGEMENT_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.DocumentsManagement,
    PermissionType: PermissionTypes.IsDeactivate,
  }

  // CIL Configuration
  public static CIL_Configuration_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CILConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static CIL_Configuration_CREATE: Permission = {
    PermissionKey: PermissionKeys.CILConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static CIL_Configuration_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CILConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static CIL_Configuration_DELETE: Permission = {
    PermissionKey: PermissionKeys.CILConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };
  public static CIL_Configuration_INACTIVE: Permission = {
    PermissionKey: PermissionKeys.CILConfiguration,
    PermissionType: PermissionTypes.IsDeactivate,
  }


  // Defect Configuration
  public static DEFECT_Configuration_ACCESS: Permission = {
    PermissionKey: PermissionKeys.DefectManagement,
    PermissionType: PermissionTypes.IsRead,
  };
  public static DEFECT_Configuration_CREATE: Permission = {
    PermissionKey: PermissionKeys.DefectManagement,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static DEFECT_Configuration_UPDATE: Permission = {
    PermissionKey: PermissionKeys.DefectManagement,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static DEFECT_Configuration_DELETE: Permission = {
    PermissionKey: PermissionKeys.DefectManagement,
    PermissionType: PermissionTypes.IsDelete,
  };

  // CIL Management
  public static CIL_Management_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CILManagement,
    PermissionType: PermissionTypes.IsRead,
  };
  public static CIL_Management_CREATE: Permission = {
    PermissionKey: PermissionKeys.CILManagement,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static CIL_Management_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CILManagement,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static CIL_Management_DELETE: Permission = {
    PermissionKey: PermissionKeys.CILManagement,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Cost Dictionary 
  public static COST_DICTIONARY_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CostDictionary,
    PermissionType: PermissionTypes.IsRead,
  };
  public static COST_DICTIONARY_CREATE: Permission = {
    PermissionKey: PermissionKeys.CostDictionary,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static COST_DICTIONARY_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CostDictionary,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static COST_DICTIONARY_DELETE: Permission = {
    PermissionKey: PermissionKeys.CostDictionary,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Reactive Maintenance Configuration
  public static REACTIVE_MAINTENANCE_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ReactiveMaintenanceConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static REACTIVE_MAINTENANCE_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.ReactiveMaintenanceConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static REACTIVE_MAINTENANCE_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ReactiveMaintenanceConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static REACTIVE_MAINTENANCE_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.ReactiveMaintenanceConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Preventive Maintanance Configuration
  public static PREVENTIVE_MAINTANANCE_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.PreventiveMaintananceConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PREVENTIVE_MAINTANANCE_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.PreventiveMaintananceConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PREVENTIVE_MAINTANANCE_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.PreventiveMaintananceConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PREVENTIVE_MAINTANANCE_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.PreventiveMaintananceConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };
  public static PREVENTIVE_MAINTANANCE_CONFIGURATION_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.PreventiveMaintananceConfiguration,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static PREVENTIVE_MAINTANANCE_CONFIGURATION_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.PreventiveMaintananceConfiguration,
    PermissionType: PermissionTypes.IsDeactivate,
  };

  // Schedule Task
  public static SCHEDULE_TASK_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ScheduleTasks,
    PermissionType: PermissionTypes.IsRead,
  };
  public static SCHEDULE_TASK_CREATE: Permission = {
    PermissionKey: PermissionKeys.ScheduleTasks,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static SCHEDULE_TASK_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ScheduleTasks,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static SCHEDULE_TASK_DELETE: Permission = {
    PermissionKey: PermissionKeys.ScheduleTasks,
    PermissionType: PermissionTypes.IsDelete,
  };

  // ScoreMatrix
  public static SCORE_MATRIX_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ScoreMatrix,
    PermissionType: PermissionTypes.IsRead,
  };
  public static SCORE_MATRIX_CREATE: Permission = {
    PermissionKey: PermissionKeys.ScoreMatrix,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static SCORE_MATRIX_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ScoreMatrix,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static SCORE_MATRIX_DELETE: Permission = {
    PermissionKey: PermissionKeys.ScoreMatrix,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Operator Execution Window
  public static OPERATOR_EXECUTION_WINDOW_ACCESS: Permission = {
    PermissionKey: PermissionKeys.OperatorExecutionWindow,
    PermissionType: PermissionTypes.IsRead,
  };
  public static OPERATOR_EXECUTION_WINDOW_CREATE: Permission = {
    PermissionKey: PermissionKeys.OperatorExecutionWindow,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static OPERATOR_EXECUTION_WINDOW_UPDATE: Permission = {
    PermissionKey: PermissionKeys.OperatorExecutionWindow,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static OPERATOR_EXECUTION_WINDOW_DELETE: Permission = {
    PermissionKey: PermissionKeys.OperatorExecutionWindow,
    PermissionType: PermissionTypes.IsDelete,
  };


  // Safety And Environment Header
  public static SAFETY_ENVIRONMENT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.BOSReporting,
    PermissionType: PermissionTypes.IsRead,
  };
  public static SAFETY_ENVIRONMENT_CREATE: Permission = {
    PermissionKey: PermissionKeys.BOSReporting,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static SAFETY_ENVIRONMENT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.BOSReporting,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static SAFETY_ENVIRONMENT_DELETE: Permission = {
    PermissionKey: PermissionKeys.BOSReporting,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Technition Execion List Screen
  public static TECHNITOIN_EXECUTION_LIST_ACCESS: Permission = {
    PermissionKey: PermissionKeys.TechnicianExecutionWindow,
    PermissionType: PermissionTypes.IsRead,
  };
  public static TECHNITOIN_EXECUTION_LIST_CREATE: Permission = {
    PermissionKey: PermissionKeys.TechnicianExecutionWindow,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static TECHNITOIN_EXECUTION_LIST_UPDATE: Permission = {
    PermissionKey: PermissionKeys.TechnicianExecutionWindow,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static TECHNITOIN_EXECUTION_LIST_DELETE: Permission = {
    PermissionKey: PermissionKeys.TechnicianExecutionWindow,
    PermissionType: PermissionTypes.IsDelete,
  };
  // ====> TDC Management <====
  // TDC Item Configuration
  public static TDC_ITEM_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ItemConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static TDC_ITEM_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.ItemConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static TDC_ITEM_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ItemConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static TDC_ITEM_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.ItemConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };

  // TDC MASTER CATEGORY CONFIGURATION
  public static TDC_CAT_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.TDCMaster,
    PermissionType: PermissionTypes.IsRead,
  };
  public static TDC_CAT_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.TDCMaster,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static TDC_CAT_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.TDCMaster,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static TDC_CAT_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.TDCMaster,
    PermissionType: PermissionTypes.IsDelete,
  };

  // TDC CONFIGURATION
  public static TDC_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ConfigurationandMapping,
    PermissionType: PermissionTypes.IsRead,
  };
  public static TDC_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.ConfigurationandMapping,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static TDC_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ConfigurationandMapping,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static TDC_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.ConfigurationandMapping,
    PermissionType: PermissionTypes.IsDelete,
  };

  // TDC DATA POINTS 
  public static TDC_DATAPOINTS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.TDCDataPoint,
    PermissionType: PermissionTypes.IsRead,
  };
  public static TDC_DATAPOINTS_CREATE: Permission = {
    PermissionKey: PermissionKeys.TDCDataPoint,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static TDC_DATAPOINTS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.TDCDataPoint,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static TDC_DATAPOINTS_DELETE: Permission = {
    PermissionKey: PermissionKeys.TDCDataPoint,
    PermissionType: PermissionTypes.IsDelete,
  };

  // TDC INPUT SCREEN 
  public static TDC_INPUT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.TDCInput,
    PermissionType: PermissionTypes.IsRead,
  };
  public static TDC_INPUT_CREATE: Permission = {
    PermissionKey: PermissionKeys.TDCInput,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static TDC_INPUT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.TDCInput,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static TDC_INPUT_DELETE: Permission = {
    PermissionKey: PermissionKeys.TDCInput,
    PermissionType: PermissionTypes.IsDelete,
  };

  // TDC ANALYSIS 
  public static TDC_ANALYSIS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.TDCAnalysis,
    PermissionType: PermissionTypes.IsRead,
  };
  public static TDC_ANALYSIS_CREATE: Permission = {
    PermissionKey: PermissionKeys.TDCAnalysis,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static TDC_ANALYSIS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.TDCAnalysis,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static TDC_ANALYSIS_DELETE: Permission = {
    PermissionKey: PermissionKeys.TDCAnalysis,
    PermissionType: PermissionTypes.IsDelete,
  };

  // TDC ACTUAL ENTRY 
  public static TDC_ACTUAL_ACCESS: Permission = {
    PermissionKey: PermissionKeys.TDCActualEntry,
    PermissionType: PermissionTypes.IsRead,
  };
  public static TDC_ACTUAL_CREATE: Permission = {
    PermissionKey: PermissionKeys.TDCActualEntry,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static TDC_ACTUAL_UPDATE: Permission = {
    PermissionKey: PermissionKeys.TDCActualEntry,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static TDC_ACTUAL_DELETE: Permission = {
    PermissionKey: PermissionKeys.TDCActualEntry,
    PermissionType: PermissionTypes.IsDelete,
  };

  // TDC MASTER 
  public static TDC_MASTER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.TDCMaster,
    PermissionType: PermissionTypes.IsRead,
  };
  public static TDC_MASTER_CREATE: Permission = {
    PermissionKey: PermissionKeys.TDCMaster,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static TDC_MASTER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.TDCMaster,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static TDC_MASTER_DELETE: Permission = {
    PermissionKey: PermissionKeys.TDCMaster,
    PermissionType: PermissionTypes.IsDelete,
  };

  // KPI Master Dashboard 
  public static KPI_MASTER_DASHBOARD_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MainKPIs,
    PermissionType: PermissionTypes.IsRead,
  };
  public static KPI_MASTER_DASHBOARD_CREATE: Permission = {
    PermissionKey: PermissionKeys.MainKPIs,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static KPI_MASTER_DASHBOARD_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MainKPIs,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static KPI_MASTER_DASHBOARD_DELETE: Permission = {
    PermissionKey: PermissionKeys.MainKPIs,
    PermissionType: PermissionTypes.IsDelete,
  };
  // RM Dashboard 
  public static RM_DASHBOARD_ACCESS: Permission = {
    PermissionKey: PermissionKeys.RMDashboard,
    PermissionType: PermissionTypes.IsRead,
  };
  public static RM_DASHBOARD_CREATE: Permission = {
    PermissionKey: PermissionKeys.RMDashboard,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static RM_DASHBOARD_UPDATE: Permission = {
    PermissionKey: PermissionKeys.RMDashboard,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static RM_DASHBOARD_DELETE: Permission = {
    PermissionKey: PermissionKeys.RMDashboard,
    PermissionType: PermissionTypes.IsDelete,
  };

  // PM Dashboard 
  public static PM_DASHBOARD_ACCESS: Permission = {
    PermissionKey: PermissionKeys.PMDashboard,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PM_DASHBOARD_CREATE: Permission = {
    PermissionKey: PermissionKeys.PMDashboard,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PM_DASHBOARD_UPDATE: Permission = {
    PermissionKey: PermissionKeys.PMDashboard,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PM_DASHBOARD_DELETE: Permission = {
    PermissionKey: PermissionKeys.PMDashboard,
    PermissionType: PermissionTypes.IsDelete,
  };
  // Distribution Group Mapping 

  public static Distribution_Group_Mapping_ACCESS: Permission = {
    PermissionKey: PermissionKeys.DistributionMapping,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Distribution_Group_Mapping_CREATE: Permission = {
    PermissionKey: PermissionKeys.DistributionMapping,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Distribution_Group_Mapping_UPDATE: Permission = {
    PermissionKey: PermissionKeys.DistributionMapping,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Distribution_Group_Mapping_DELETE: Permission = {
    PermissionKey: PermissionKeys.DistributionMapping,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Manager Execution Window
  public static MANAGER_EXECUTION_WINDOW_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ManagerExecutionWindow,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MANAGER_EXECUTION_WINDOW_CREATE: Permission = {
    PermissionKey: PermissionKeys.ManagerExecutionWindow,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MANAGER_EXECUTION_WINDOW_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ManagerExecutionWindow,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static MANAGER_EXECUTION_WINDOW_DELETE: Permission = {
    PermissionKey: PermissionKeys.ManagerExecutionWindow,
    PermissionType: PermissionTypes.IsDelete,
  };


  //Permission For AM Action Plan Screen

  public static AM_ActionPlan_ACCESS: Permission = {
    PermissionKey: PermissionKeys.AMActionPlan,
    PermissionType: PermissionTypes.IsRead,
  };
  public static AM_ActionPlan_CREATE: Permission = {
    PermissionKey: PermissionKeys.AMActionPlan,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static AM_ActionPlan_UPDATE: Permission = {
    PermissionKey: PermissionKeys.AMActionPlan,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static AM_ActionPlan_DELETE: Permission = {
    PermissionKey: PermissionKeys.AMActionPlan,
    PermissionType: PermissionTypes.IsDelete,
  };
  public static AM_ActionPlan_Approve: Permission = {
    PermissionKey: PermissionKeys.AMActionPlan,
    PermissionType: PermissionTypes.IsApprove,
  };

  public static LossMaster_ACCESS: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisMasterData,
    PermissionType: PermissionTypes.IsRead,
  };
  public static LossMaster_CREATE: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisMasterData,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static LossMaster_UPDATE: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisMasterData,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static LossMaster_DELETE: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisMasterData,
    PermissionType: PermissionTypes.IsDelete,
  };

  public static GapAnalysis_ACCESS: Permission = {
    PermissionKey: PermissionKeys.GapAnalysis,
    PermissionType: PermissionTypes.IsRead,
  };
  public static GapAnalysis_CREATE: Permission = {
    PermissionKey: PermissionKeys.GapAnalysis,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static GapAnalysis_UPDATE: Permission = {
    PermissionKey: PermissionKeys.GapAnalysis,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static GapAnalysis_DELETE: Permission = {
    PermissionKey: PermissionKeys.GapAnalysis,
    PermissionType: PermissionTypes.IsDelete,
  };
  // Gemba Walk Permission
  public static GembaWalk_ACCESS: Permission = {
    PermissionKey: PermissionKeys.GembaWalk,
    PermissionType: PermissionTypes.IsRead,
  };
  public static GembaWalk_CREATE: Permission = {
    PermissionKey: PermissionKeys.GembaWalk,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static GembaWalk_UPDATE: Permission = {
    PermissionKey: PermissionKeys.GembaWalk,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static GembaWalk_DELETE: Permission = {
    PermissionKey: PermissionKeys.GembaWalk,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Gemba Walk Permission
  public static MEETING_SCHEDULAR_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MeetingSchedular,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MEETING_SCHEDULAR_CREATE: Permission = {
    PermissionKey: PermissionKeys.MeetingSchedular,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MEETING_SCHEDULAR_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MeetingSchedular,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static MEETING_SCHEDULAR_DELETE: Permission = {
    PermissionKey: PermissionKeys.MeetingSchedular,
    PermissionType: PermissionTypes.IsDelete,
  };
  public static MEETING_SCHEDULAR_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.MeetingSchedular,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static MEETING_SCHEDULAR_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.MeetingSchedular,
    PermissionType: PermissionTypes.IsDeactivate,
  };


  // Meeting Matrix Permissions
  public static MEETING_MATRIX_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MeetingMatrix,
    PermissionType: PermissionTypes.IsRead,
  }
  public static MEETING_MATRIX_CREATE: Permission = {
    PermissionKey: PermissionKeys.MeetingMatrix,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static MEETING_MATRIX_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MeetingMatrix,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static MEETING_MATRIX_DELETE: Permission = {
    PermissionKey: PermissionKeys.MeetingMatrix,
    PermissionType: PermissionTypes.IsDelete,
  }

  // KPI Milestone Permissions
  public static KPI_MILESTONE_ACCESS: Permission = {
    PermissionKey: PermissionKeys.KPIMilestone,
    PermissionType: PermissionTypes.IsRead,
  }
  public static KPI_MILESTONE_CREATE: Permission = {
    PermissionKey: PermissionKeys.KPIMilestone,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static KPI_MILESTONE_UPDATE: Permission = {
    PermissionKey: PermissionKeys.KPIMilestone,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static KPI_MILESTONE_DELETE: Permission = {
    PermissionKey: PermissionKeys.KPIMilestone,
    PermissionType: PermissionTypes.IsDelete,
  }

  // Performance Master Settings Permissions
  public static PERFORMANCE_MASTER_SETTINGS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.PerformanceMasterSettings,
    PermissionType: PermissionTypes.IsRead,
  }
  public static PERFORMANCE_MASTER_SETTINGS_CREATE: Permission = {
    PermissionKey: PermissionKeys.PerformanceMasterSettings,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static PERFORMANCE_MASTER_SETTINGS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.PerformanceMasterSettings,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static PERFORMANCE_MASTER_SETTINGS_DELETE: Permission = {
    PermissionKey: PermissionKeys.PerformanceMasterSettings,
    PermissionType: PermissionTypes.IsDelete,
  }

  // Meeting Action Permissions
  public static MEETING_ACTION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MeetingActionPlan,
    PermissionType: PermissionTypes.IsRead,
  }
  public static MEETING_ACTION_CREATE: Permission = {
    PermissionKey: PermissionKeys.MeetingActionPlan,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static MEETING_ACTION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MeetingActionPlan,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static MEETING_ACTION_DELETE: Permission = {
    PermissionKey: PermissionKeys.MeetingActionPlan,
    PermissionType: PermissionTypes.IsDelete,
  }

  //Audit Execution 
  // public static Audit_Execution_ACCESS: Permission = {
  //   PermissionKey: PermissionKeys.AuditExecution,
  //   PermissionType: PermissionTypes.IsRead,
  // }
  // public static Audit_Execution_CREATE: Permission = {
  //   PermissionKey: PermissionKeys.AuditExecution,
  //   PermissionType: PermissionTypes.IsWrite,
  // }
  // public static Audit_Execution_UPDATE: Permission = {
  //   PermissionKey: PermissionKeys.AuditExecution,
  //   PermissionType: PermissionTypes.IsUpdate,
  // }
  // public static Audit_Execution_DELETE: Permission = {
  //   PermissionKey: PermissionKeys.AuditExecution,
  //   PermissionType: PermissionTypes.IsDelete,
  // }

  //NEW DEFECT Dashboard Permission 
  public static Defect_Dashboard_ACCESS: Permission = {
    PermissionKey: PermissionKeys.NewDefectDashboard,
    PermissionType: PermissionTypes.IsRead,
  }
  public static Defect_Dashboard_CREATE: Permission = {
    PermissionKey: PermissionKeys.NewDefectDashboard,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static Defect_Dashboard_UPDATE: Permission = {
    PermissionKey: PermissionKeys.NewDefectDashboard,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static Defect_Dashboard_DELETE: Permission = {
    PermissionKey: PermissionKeys.NewDefectDashboard,
    PermissionType: PermissionTypes.IsDelete,
  }


  //NEW Five S and Gemba Dashboard Permission 
  public static New_FiveSGemba_ACCESS: Permission = {
    PermissionKey: PermissionKeys.NewFiveSGembaDashboard,
    PermissionType: PermissionTypes.IsRead,
  }
  public static New_FiveSGemba_CREATE: Permission = {
    PermissionKey: PermissionKeys.NewFiveSGembaDashboard,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static New_FiveSGemba_UPDATE: Permission = {
    PermissionKey: PermissionKeys.NewFiveSGembaDashboard,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static New_FiveSGemba_DELETE: Permission = {
    PermissionKey: PermissionKeys.NewFiveSGembaDashboard,
    PermissionType: PermissionTypes.IsDelete,
  }
  //NEW CIL Dashboard Permission 
  public static New_CILDashboard_ACCESS: Permission = {
    PermissionKey: PermissionKeys.NewCILDashboard,
    PermissionType: PermissionTypes.IsRead,
  }
  public static New_CILDashboard_CREATE: Permission = {
    PermissionKey: PermissionKeys.NewCILDashboard,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static New_CILDashboard_UPDATE: Permission = {
    PermissionKey: PermissionKeys.NewCILDashboard,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static New_CILDashboard_DELETE: Permission = {
    PermissionKey: PermissionKeys.NewCILDashboard,
    PermissionType: PermissionTypes.IsDelete,
  }
  //Process Confirmation Dashboard Permissions 
  public static Process_ConfirmationDashboard_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ProcessConfirmationDashboard,
    PermissionType: PermissionTypes.IsRead,
  }
  public static Process_ConfirmationDashboard_CREATE: Permission = {
    PermissionKey: PermissionKeys.ProcessConfirmationDashboard,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static Process_ConfirmationDashboard_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ProcessConfirmationDashboard,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static Process_ConfirmationDashboard_DELETE: Permission = {
    PermissionKey: PermissionKeys.ProcessConfirmationDashboard,
    PermissionType: PermissionTypes.IsDelete,
  }
  //Audit Execution 
  public static Audit_Execution_ACCESS: Permission = {
    PermissionKey: PermissionKeys.AuditExecution,
    PermissionType: PermissionTypes.IsRead,
  }
  public static Audit_Execution_CREATE: Permission = {
    PermissionKey: PermissionKeys.AuditExecution,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static Audit_Execution_UPDATE: Permission = {
    PermissionKey: PermissionKeys.AuditExecution,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static Audit_Execution_DELETE: Permission = {
    PermissionKey: PermissionKeys.AuditExecution,
    PermissionType: PermissionTypes.IsDelete,
  }

  // Meeting Matrix V2 Permissions
  public static MEETING_MATRIX_V2_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MeetingMatrixV2,
    PermissionType: PermissionTypes.IsRead,
  }
  public static MEETING_MATRIX_V2_CREATE: Permission = {
    PermissionKey: PermissionKeys.MeetingMatrixV2,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static MEETING_MATRIX_V2_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MeetingMatrixV2,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static MEETING_MATRIX_V2_DELETE: Permission = {
    PermissionKey: PermissionKeys.MeetingMatrixV2,
    PermissionType: PermissionTypes.IsDelete,
  }

  // Document Configuration
  public static Document_Configuration_ACCESS: Permission = {
    PermissionKey: PermissionKeys.WFConfiguration,
    PermissionType: PermissionTypes.IsRead,
  }
  public static Document_Configuration_CREATE: Permission = {
    PermissionKey: PermissionKeys.WFConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static Document_Configuration_UPDATE: Permission = {
    PermissionKey: PermissionKeys.WFConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static Document_Configuration_DELETE: Permission = {
    PermissionKey: PermissionKeys.WFConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  }

  // Document Admin Configuration
  public static Document_Admin_Configuration_ACCESS: Permission = {
    PermissionKey: PermissionKeys.AdminConfiguration,
    PermissionType: PermissionTypes.IsRead,
  }
  public static Document_Admin_Configuration_CREATE: Permission = {
    PermissionKey: PermissionKeys.AdminConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static Document_Admin_Configuration_UPDATE: Permission = {
    PermissionKey: PermissionKeys.AdminConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static Document_Admin_Configuration_DELETE: Permission = {
    PermissionKey: PermissionKeys.AdminConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  }

  // DocumentManagementMaster Permissions
  public static DOCUMENT_MANAGEMENT_MASTER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.DocumentManagementMaster,
    PermissionType: PermissionTypes.IsRead,
  }
  public static DOCUMENT_MANAGEMENT_MASTER_CREATE: Permission = {
    PermissionKey: PermissionKeys.DocumentManagementMaster,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static DOCUMENT_MANAGEMENT_MASTER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.DocumentManagementMaster,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static DOCUMENT_MANAGEMENT_MASTER_DELETE: Permission = {
    PermissionKey: PermissionKeys.DocumentManagementMaster,
    PermissionType: PermissionTypes.IsDelete,
  }
  // TDC Master Data Permissions
  public static TDC_MASTER_DATA_ACCESS: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisMasterData,
    PermissionType: PermissionTypes.IsRead,
  }
  public static TDC_MASTER_DATA_CREATE: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisMasterData,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static TDC_MASTER_DATA_UPDATE: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisMasterData,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static TDC_MASTER_DATA_DELETE: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisMasterData,
    PermissionType: PermissionTypes.IsDelete,
  }

  // Cost Master Data Permissions
  public static COST_MASTER_DATA_ACCESS: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisMasterData,
    PermissionType: PermissionTypes.IsRead,
  }
  public static COST_MASTER_DATA_CREATE: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisMasterData,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static COST_MASTER_DATA_UPDATE: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisMasterData,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static COST_MASTER_DATA_DELETE: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisMasterData,
    PermissionType: PermissionTypes.IsDelete,
  }

  // Cost Master Data Permissions
  public static LOSS_DASHBOARD_ACCESS: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisDashboard,
    PermissionType: PermissionTypes.IsRead,
  }
  public static LOSS_DASHBOARD_CREATE: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisDashboard,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static LOSS_DASHBOARD_UPDATE: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisDashboard,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static LOSS_DASHBOARD_DELETE: Permission = {
    PermissionKey: PermissionKeys.LossAnalysisDashboard,
    PermissionType: PermissionTypes.IsDelete,
  }

  // Over All Action Plan screen
  public static OverAll_Action_Plan_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ActionPlan,
    PermissionType: PermissionTypes.IsRead,
  }
  public static OverAll_Action_Plan_CREATE: Permission = {
    PermissionKey: PermissionKeys.ActionPlan,
    PermissionType: PermissionTypes.IsWrite,
  }
  public static OverAll_Action_Plan_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ActionPlan,
    PermissionType: PermissionTypes.IsUpdate,
  }
  public static OverAll_Action_Plan_DELETE: Permission = {
    PermissionKey: PermissionKeys.ActionPlan,
    PermissionType: PermissionTypes.IsDelete,
  }
}
